import { combineReducers, configureStore } from '@reduxjs/toolkit'
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist'
import persistReducer from 'redux-persist/es/persistReducer'

import storage from 'redux-persist/lib/storage'

import userSlice from '../pages/User/ducks/userSlice'
import organizationSlice from '../pages/Organization/ducks/organizationSlice'
import loginSlice from '../pages/Login/ducks/loginSlice'
import alertSlice from '../shared/components/alert/ducks/alertSlice'
import modalSlice from '../shared/components/modal/ducks/modalSlice'
import serviceProviderSlice from '../pages/ServiceProvider/ducks/serviceProviderSlice'

const rootReducer = combineReducers({
  alert: alertSlice,
  user: userSlice,
  organization: organizationSlice,
  login: loginSlice,
  modal: modalSlice,
  serviceProvider: serviceProviderSlice,
})

const devToolsCompose = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__

export const config = {
  key: 'root',
  storage: storage,
  whitelist: ['login'],
  transforms: [],
}

const persistRootReducer = persistReducer(config, rootReducer)

const store = configureStore({
  reducer: persistRootReducer,
  devTools:
    process.env.NODE_ENV === 'development'
      ? { trace: true, traceLimit: 25 }
      : false,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store
